import { RiCloseLine, RiSearchLine } from '@remixicon/react';
import { useEditor } from '@lidojs/design-editor';
import React, { FC, useState, useRef, ChangeEvent } from 'react';
import { isMobile } from 'react-device-detect';
import tw from 'twin.macro';
import TemplatePanel from './TemplatePanel';
import { debounce } from 'lodash';
import { Template } from './data/template';
import IconButton from '../../IconButton';
import { useTranslation } from 'react-i18next';

const TemplateContent: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation();

  const [keyword, setKeyword] = useState<string>('');
  const qRef = useRef<HTMLInputElement>(null);

  const { actions, activePage } = useEditor((state) => ({
    activePage: state.activePage,
  }));

  const addPage = async (template: Template) => {
    const { elements, ...other } = template;

    actions.setPage(activePage, elements);
    if (isMobile) {
      onClose();
    }
  };

  const handleSearch = async (e: ChangeEvent<HTMLInputElement>) => {
    setKeyword(qRef.current?.value || '');
  };

  return (
    <div
      css={(theme) => ({
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        overflowY: 'auto',
        display: 'flex',
      })}
    >
      <div
        css={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          height: 50,
          borderBottom: `1px solid ${theme.colors.stroke}`,
          padding: '0 20px',
        })}
      >
        <p
          css={(theme) => ({
            lineHeight: '48px',
            fontWeight: 600,
            color: theme.colors.content,
            flexGrow: 1,
          })}
        >
          {t('page_editor.general.template')}
        </p>
        <IconButton onClick={onClose}>
          <RiCloseLine size={20} />
        </IconButton>
      </div>
      <div
        css={(theme) => ({
          flexDirection: 'column',
          overflowY: 'auto',
          display: 'flex',
          flexGrow: 1,
        })}
      >
        <div
          css={(theme) => ({
            borderRadius: 4,
            border: `1px solid ${theme.colors.stroke}`,
            margin: 16,
            marginBottom: 8,
          })}
        >
          <div
            css={(theme) => ({
              height: 40,
              borderRadius: 4,
              paddingLeft: 12,
              display: 'flex',
              alignItems: 'center',
              overflow: 'hidden',
            })}
          >
            <div
              css={(theme) => ({
                fontSize: 24,
                marginRight: 8,
                flexShrink: 0,
              })}
            >
              <RiSearchLine size={20} />
            </div>
            <input
              ref={qRef}
              css={(theme) => ({
                width: '100%',
                height: '100%',
                backgroundColor: theme.colors.input,
                paddingLeft: 8,
              })}
              type={'text'}
              onInput={debounce(handleSearch, 400)}
            />
          </div>
        </div>

        <TemplatePanel keyword={keyword} type="frame" addPage={addPage} />
      </div>
    </div>
  );
};

export default TemplateContent;
